/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicarePrimaryDiagnosis } from './MedicarePrimaryDiagnosis';
import {
    MedicarePrimaryDiagnosisFromJSON,
    MedicarePrimaryDiagnosisFromJSONTyped,
    MedicarePrimaryDiagnosisToJSON,
    MedicarePrimaryDiagnosisToJSONTyped,
} from './MedicarePrimaryDiagnosis';
import type { PtOtClinicalCategory } from './PtOtClinicalCategory';
import {
    PtOtClinicalCategoryFromJSON,
    PtOtClinicalCategoryFromJSONTyped,
    PtOtClinicalCategoryToJSON,
    PtOtClinicalCategoryToJSONTyped,
} from './PtOtClinicalCategory';

/**
 * 
 * @export
 * @interface PtOtDiagnosisToClinicalCategoryMapping
 */
export interface PtOtDiagnosisToClinicalCategoryMapping {
    /**
     * 
     */
    diagnosis: MedicarePrimaryDiagnosis;
    /**
     * 
     */
    clinical_category: PtOtClinicalCategory;
}



/**
 * Check if a given object implements the PtOtDiagnosisToClinicalCategoryMapping interface.
 */
export function instanceOfPtOtDiagnosisToClinicalCategoryMapping(value: object): value is PtOtDiagnosisToClinicalCategoryMapping {
    if (!('diagnosis' in value) || value['diagnosis'] === undefined) return false;
    if (!('clinical_category' in value) || value['clinical_category'] === undefined) return false;
    return true;
}

export function PtOtDiagnosisToClinicalCategoryMappingFromJSON(json: any): PtOtDiagnosisToClinicalCategoryMapping {
    return PtOtDiagnosisToClinicalCategoryMappingFromJSONTyped(json, false);
}

export function PtOtDiagnosisToClinicalCategoryMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtOtDiagnosisToClinicalCategoryMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'diagnosis': MedicarePrimaryDiagnosisFromJSON(json['diagnosis']),
        'clinical_category': PtOtClinicalCategoryFromJSON(json['clinical_category']),
    };
}

export function PtOtDiagnosisToClinicalCategoryMappingToJSON(json: any): PtOtDiagnosisToClinicalCategoryMapping {
    return PtOtDiagnosisToClinicalCategoryMappingToJSONTyped(json, false);
}

export function PtOtDiagnosisToClinicalCategoryMappingToJSONTyped(value?: PtOtDiagnosisToClinicalCategoryMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'diagnosis': MedicarePrimaryDiagnosisToJSON(value['diagnosis']),
        'clinical_category': PtOtClinicalCategoryToJSON(value['clinical_category']),
    };
}

